import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function Reports() {
  return (
    <>
      <Typography variant="h2">
        Chcę zgłosić przekroczenie granic lub przemoc
      </Typography>
      <Typography variant="body1">
        Jeśli doświadczasz przemocy ze strony innego członka lub członkini ZHP,
        jesteś świadkiem sytuacji naruszenia granic lub dowiedziałaś/eś się o
        takiej sytuacji, zgłoś tę sprawę poprzez niniejszy formularz oraz
        poinformuj o niej komendanta hufca osoby poszkodowanej.
      </Typography>
      <Typography variant="body1">
        Zgłoszenie sprawy przez system pozwoli na rozpoczęcie procesu reagowania
        w Twojej sprawie. O tym, kto będzie prowadził interwencję, decyduje
        właściwy komendant (najczęściej Twój komendant hufca, chyba, że sprawa
        dotyczy wyższego poziomu struktury). Osobę prowadzącą interwencję będzie
        wspierać  psycholog_żka ze Strefy Pomocy ZHP.
      </Typography>
      <Typography variant="body1">
        Wypełnij te pola, gdzie znasz i chcesz podać odpowiedzi. Pamiętaj, że im
        więcej informacji przekażesz, tym większe jest prawdopodobieństwo że uda
        się daną sytuację zaopiekować.
      </Typography>
      <Typography variant="body1">
        Jeśli jest Ci trudno pisać o tej sytuacji, zgłoszenia możesz dokonać
        także drogą telefoniczną, dzwoniąc do Stefy Pomocy. Strefa Pomocy jest
        czynna w godzinach 15:00 - 21:00 w dni powszednie pod numerem 669 116
        116. Rozpoczynając rozmowę podkreśl, że dzwonisz w sprawie zgłoszenia
        sytuacji przekroczenia granic/doświadczenia przemocy.
      </Typography>

      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Link
            to="/formularze/przemoc"
            style={{ width: "100%", textDecoration: "none" }}
          >
            <Box
              sx={{
                color: "white",
                backgroundColor: "#86a315",
                borderRadius: 2,
                p: 4,
                height: "100%",
                width: "100%",
                minHeight: 180,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transition:
                  "background-color 0.3s, transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  backgroundColor: "#5d2f88",
                  transform: "translateY(-4px)",
                  boxShadow: 3,
                },
              }}
            >
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 900 }}>
                Formularz zgłoszenia przekroczenia granic
              </Typography>
              <Typography variant="body1" color="white">
                Poziom hufca, Chorągwi oraz Głównej Kwatery
              </Typography>
            </Box>
          </Link>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Link
            to="/formularze/mobbing"
            style={{ width: "100%", textDecoration: "none" }}
          >
            <Box
              sx={{
                color: "white",
                backgroundColor: "#F58220",
                borderRadius: 2,
                p: 4,
                height: "100%",
                width: "100%",
                minHeight: 180,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transition:
                  "background-color 0.3s, transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  backgroundColor: "#203581",
                  transform: "translateY(-4px)",
                  boxShadow: 3,
                },
              }}
            >
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 900 }}>
                Formularz zgłoszenia mobbingu w Głównej Kwaterze
              </Typography>
              <Typography variant="body1" color="white">
                Wydziały, zespoły oraz pracownicy Głównej Kwatery
              </Typography>
            </Box>
          </Link>
        </Grid>
      </Grid>
    </>
  );
}
